export const GRADES = [
    {
        data: 'TOD',
        view: 'TOD'
    },
    {
        data: 'PS1',
        view: 'PS1'
    },
    {
        data: 'PS2',
        view: 'PS2'
    },
    {
        data: 'PRE_K',
        view: 'Pre K'
    },
    {
        data: 'TK',
        view: 'TK'
    },
    {
        data: 'K',
        view: 'K'
    },
    {
        data: 'FIRST',
        view: '1'
    },
    {
        data: 'SECOND',
        view: '2'
    },
    {
        data: 'THIRD',
        view: '3'
    },
    {
        data: 'FOURTH',
        view: '4'
    },
    {
        data: 'FIFTH',
        view: '5'
    },
    {
        data: 'SIXTH',
        view: '6'
    },
    {
        data: 'SEVENTH',
        view: '7'
    },
    {
        data: 'EIGHTH',
        view: '8'
    },
    {
        data: 'NINTH',
        view: '9'
    },
    {
        data: 'TENTH',
        view: '10'
    },
    {
        data: 'ELEVENTH',
        view: '11'
    },
    {
        data: 'TWELFTH',
        view: '12'
    }
];


// WEBPACK FOOTER //
// ./src/constants/school-grades.js